import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown'
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt'
import dateFilterStyles from './modules/dateFilter.module.scss'
import logoSvg from 'src/assets/images/logo-horizon.svg'
import reactSelect from './modules/react-select/reactSelect'
import DropdownIndicator from './modules/react-select/DropdownIndicator'
import ClearIndicator from './modules/react-select/ClearIndicator'
import SelectedOptionIcon from './modules/react-select/SelectedOptionIcon'

const stylesMap = {
    DatePickerInput: {
        placeholder: 'dd/mm/yyyy',
    },
    DateFilter: {
        inputIcon: (
            <FontAwesomeIcon
                icon={faCalendarAlt}
                title="Select a date"
                className={dateFilterStyles.inputIcon}
                fixedWidth={true}
            />
        ),
    },
    DropdownButton: {
        icon: <FontAwesomeIcon icon={faChevronDown} title="Toggle dropdown" />,
    },
    _ReactSelectAdapter: {
        /**
         * Used to style the internals of the react-select. The [reactSelect] import
         * is actually a js file instead of a scss file because react-select uses
         * css in jsx for styling
         */
        reactSelectStyles: reactSelect,
        components: {
            LoadingIndicator: null,
        },
    },
    SelectDropdownIndicator: {
        content: <DropdownIndicator />,
    },
    SelectClearIndicator: {
        content: <ClearIndicator />,
    },
    SelectOption: {
        icon: <SelectedOptionIcon />,
    },
}

const ccpTheme = {
    name: '656', //TODO FIXME temp set this to org id until name_key is implemented
    config: {
        logo: logoSvg,
    },
    getProps: componentName => stylesMap[componentName],
}

export default ccpTheme
